import React, { memo } from "react";
import { slidesToShowPlugin } from "@brainhubeu/react-carousel";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";

import LastListItem from "./LastListItem";
import TestimonialListItem from "./TestimonialsListItem";
import theme from "../../config/theme";
import Carousel from "../carousel/Carousel";
import Section from "../layout/utils/Section";

const Testimonials: React.FC<ITestimonialsProps> = ({
  testimonialData,
  titleProps,
  children,
  ...props
}) => {
  const isDownSm = useMediaQuery(theme.breakpoints.down("sm"));
  const isDownMd = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Section {...props}>
      <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography align="center" {...(titleProps || {})}>
              {titleProps?.children || "See what Our Learners are Saying"}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box mt={{ xs: 4, md: 8 }}>
              <Carousel
                showButtons={true}
                plugins={[
                  {
                    resolve: slidesToShowPlugin,
                    options: {
                      numberOfSlides: isDownSm ? 1 : isDownMd ? 2 : 3,
                    },
                  },
                ]}
              >
                {testimonialData.map(
                  ({ id, name, image, imageAlt, description, title }, idx) =>
                    idx === testimonialData.length - 1 ? (
                      <LastListItem key={id} description={description} />
                    ) : (
                      <TestimonialListItem
                        key={id}
                        name={name}
                        title={title}
                        description={description}
                        image={image}
                        imageAlt={imageAlt}
                      />
                    )
                )}
              </Carousel>
            </Box>
          </Grid>
        </Grid>
        {children}
      </>
    </Section>
  );
};

export default memo(Testimonials);
